import type { CSSProperties } from "react";
import type { SxProps, Theme } from "@mui/material";
import { IBoardMissions } from "@/widgets/production-floor/interfaces/board-missions";

export const PROOFING_ROW_BG = "var(--theme-primary-50, #ebecef)";

/** Keep proofing row tooltips below table cell menus/popovers. */
export const PROOFING_ROW_TOOLTIP_Z_INDEX = 1200;

/** Above MUI Tooltip default (1500) for production-floor table dropdowns. */
export const PRODUCTION_FLOOR_TABLE_MENU_Z_INDEX = 99999999;

/** Above production-floor board-mission drawer (999999). */
export const PRODUCTION_FLOOR_NESTED_MODAL_Z_INDEX = 1_000_000_000;

/** Date/time pickers opened from nested production-floor modals. */
export const PRODUCTION_FLOOR_DATE_PICKER_Z_INDEX =
  PRODUCTION_FLOOR_NESTED_MODAL_Z_INDEX + 100;

/** Visible on proofing row bg (#ebecef / theme primary-50); #EAECF0 blends in. */
export const PROOFING_TABLE_CELL_BORDER = {
  borderLeft: "1px solid #D0D5DD",
  borderRight: "1px solid #D0D5DD",
  borderBottom: "1px solid #D0D5DD",
} as const;

export const proofingTableCellStyle: CSSProperties = {
  backgroundColor: PROOFING_ROW_BG,
  ...PROOFING_TABLE_CELL_BORDER,
};

export const proofingTableRowSx: SxProps<Theme> = {
  backgroundColor: `${PROOFING_ROW_BG} !important`,
  "&.MuiTableRow-root:nth-of-type(even), &.MuiTableRow-root:nth-of-type(odd)":
    {
      backgroundColor: `${PROOFING_ROW_BG} !important`,
    },
  "& .MuiTableCell-root": {
    backgroundColor: `${PROOFING_ROW_BG} !important`,
    borderLeft: `${PROOFING_TABLE_CELL_BORDER.borderLeft} !important`,
    borderRight: `${PROOFING_TABLE_CELL_BORDER.borderRight} !important`,
    borderBottom: `${PROOFING_TABLE_CELL_BORDER.borderBottom} !important`,
  },
};

export const proofingKanbanCardSx: SxProps<Theme> = {
  backgroundColor: `${PROOFING_ROW_BG} !important`,
};

export const isBoardMissionInProofingProcess = (
  mission?: IBoardMissions | Record<string, any> | null
) => Boolean(mission?.isInProofingProcess);

export const isBoardMissionFinishedProofing = (
  mission?: IBoardMissions | Record<string, any> | null
) => Boolean(mission?.isFinishedProofing);

export const getProofingTableRowSx = (
  mission?: IBoardMissions | Record<string, any> | null,
  additionalSx?: SxProps<Theme>
): SxProps<Theme> | undefined => {
  const proofingSx = isBoardMissionInProofingProcess(mission)
    ? proofingTableRowSx
    : undefined;

  if (!proofingSx && !additionalSx) {
    return undefined;
  }

  return {
    ...(proofingSx ?? {}),
    ...(additionalSx ?? {}),
  };
};
